import React, { useEffect, useMemo, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import applyType from '../../utils/metadataUtils';
import { getVehicleConfiguration } from '../../services/vehicles';
import { generateRandomString } from '../../utils/string';
import { jsonPathToValue } from '../../utils/json';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';
import useMetaData from '../../hooks/useMetaData';
import VehicleLoader from './TabLoader';
import GridLabels from './GridLabels';

const Vehicle = () => {
  const { reservationId } = useParams<{ reservationId: string }>();
  const vehicleMetaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.vehicleTab);
  const [configData, setConfigData] = useState<any>();

  useEffect(() => {
    if (reservationId) {
      getVehicleConfiguration(reservationId).then((response) => setConfigData(response));
    }
  }, [reservationId]);
  const vehicleConfigLabels = useMemo(
    () =>
      configData
        ? vehicleMetaData?.rows?.map((row: any) => {
            const value = jsonPathToValue(configData, row.property);
            const isVIN = row.propertyName === 'VIN';

            if (isVIN) {
              return {
                label: row.propertyName,
                title: value || 'Not Assigned',
                id: generateRandomString(10),
                isOptional: row?.isOptional,
              };
            }

            return {
              label: row?.propertyName,
              title: applyType(row.type, value),
              id: generateRandomString(10),
              isOptional: row?.isOptional,
            };
          }) || []
        : [],
    [configData, vehicleMetaData?.rows]
  );
  if (!vehicleMetaData || !configData) return <VehicleLoader loop={8} />;
  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mt={0}>
        <GridLabels
          labels={vehicleConfigLabels}
          labelSx={{ fontSize: '14px', fontWeight: '400', color: '#717171' }}
          titleSx={{
            fontSize: '16px',
            fontWeight: '500',
            color: '#3E3E3E',
          }}
        />
      </Grid>
    </Box>
  );
};

export default Vehicle;
